import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import appUrl from "../../../../constants/appUrl";
const ViewAttachment = ({ attachment }) => {
    console.log('productAttachment', attachment);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
    };

    return (
        <div className="card">
            <Slider {...settings}>
                {attachment.map((imagePath, index) => (
                    <div key={index}>
                        <img src={`${appUrl.baseUrl}/${imagePath.attachmentPath}`} style={{ width: '100%', height: 'auto' }} alt="Attachment" />
                    </div>
                ))}
            </Slider>
        </div>
    );
};

export default ViewAttachment;
